// tslint:disable:max-line-length

import React from 'react';

export const ArrowCaretUpSmall = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8.83205 6.24807C8.43623 5.65434 7.56377 5.65434 7.16795 6.24808L5.03647 9.4453C4.59343 10.1099 5.06982 11 5.86852 11H10.1315C10.9302 11 11.4066 10.1099 10.9635 9.4453L8.83205 6.24807Z" />
    </svg>
  );
};
